<template>
  <div id="overlayMinResize">
    <div class="overlayMinResizeBody">
      <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M85.7929 64.2071C86.4229 63.5771 87.5 64.0233 87.5 64.9142V86.5C87.5 87.0523 87.0523 87.5 86.5 87.5H64.9142C64.0233 87.5 63.5771 86.4229 64.2071 85.7929L72.0703 77.9297L60.6796 66.7227C60.2836 66.3331 60.281 65.6955 60.6738 65.3027L65.3027 60.6738C65.6955 60.281 66.3331 60.2836 66.7227 60.6796L77.9297 72.0703L85.7929 64.2071ZM35.7929 85.7929C36.4229 86.4229 35.9767 87.5 35.0858 87.5H13.5C12.9477 87.5 12.5 87.0523 12.5 86.5V64.9142C12.5 64.0233 13.5771 63.5771 14.2071 64.2071L22.0703 72.0703L33.2773 60.6796C33.6669 60.2836 34.3045 60.281 34.6973 60.6738L39.3262 65.3027C39.719 65.6955 39.7164 66.3331 39.3204 66.7227L27.9297 77.9297L35.7929 85.7929ZM14.2071 35.7929C13.5771 36.4229 12.5 35.9767 12.5 35.0858V13.5C12.5 12.9477 12.9477 12.5 13.5 12.5H35.0858C35.9767 12.5 36.4229 13.5771 35.7929 14.2071L27.9297 22.0703L39.3204 33.2773C39.7164 33.6669 39.719 34.3045 39.3262 34.6973L34.6973 39.3262C34.3045 39.719 33.6669 39.7164 33.2773 39.3204L22.0703 27.9297L14.2071 35.7929ZM64.2071 14.2071C63.5771 13.5771 64.0233 12.5 64.9142 12.5H86.5C87.0523 12.5 87.5 12.9477 87.5 13.5V35.0858C87.5 35.9767 86.4229 36.4229 85.7929 35.7929L77.9297 27.9297L66.7227 39.3204C66.3331 39.7164 65.6955 39.719 65.3027 39.3262L60.6738 34.6973C60.281 34.3045 60.2836 33.6669 60.6796 33.2773L72.0703 22.0703L64.2071 14.2071Z"
          fill="#0060E5" />
      </svg>
      <h3>Your browser is too small</h3>
      <p>Resize your browser to be at least 1024px wide to get back into design mode.</p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'OverlayMinResize',
  data: () => ({}),
  created() {},
  methods: {},
});
</script>

<style lang="scss">
@import '@/app/editor/scss/variables';
#overlayMinResize {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(#1c1c25, 0.9);
  display: none;
  z-index: 9999999999999999999;
  user-select: none;
  svg {
    display: inline;
    vertical-align: unset;
  }

  .overlayMinResizeBody {
    width: 450px;
    height: 400px;
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 62px 50px;
    text-align: center;

    svg {
      fill: #f55c26;
    }

    h3 {
      font-family: $fontFamily;
      font-weight: 500;
      font-size: 24px;
      line-height: 28px;
      color: #ffffff;
      letter-spacing: 0.2px;
      text-align: center;
      margin-top: 12px;
    }

    p {
      font-family: $fontFamily;
      font-size: 14px;
      color: $neutral_8;
      letter-spacing: 0.14px;
      text-align: center;
      line-height: 18px;
      margin-top: 12px;
    }
  }

  @media only screen and (max-width: 1023px) {
    display: block;
  }
}
</style>
